<template lang="html">
  <div id="floorplans_list" class="relative">
    <floorplan-list-actions/>
    <div class="center cf">
      <div class="pv3 pl4 tl f6 i moon-gray">
        {{ currentPlanListCount }}
      </div>
      <transition name="fade" mode="out-in">
        <ul class="list pa0 ma0 flex flex-wrap" v-if="!listMode" v-show="!sorting">
          <floorplan-list-tile
            v-for="(floorplan, index) in currentPlanList"
            :floorplan="floorplan"
            :index="index"
            :key="floorplan.id"
            class="tile-animate-item"
          />
        </ul>
      </transition>
      <floorplan-list-table v-if="listMode && currentPlanList.length > 0"></floorplan-list-table>
      <div v-if="currentPlanList.length === 0">
        <span v-if="!favouritesMode">No floorplans available based on current filter.</span>
        <span v-else>No favourited floorplans.</span>
      </div>
      <div class="action-bar-spacer w-100"></div>
    </div>
    <!-- <back-to-top/> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BackToTopComponent from '@/components/BackToTop';
import FloorplanListActionsComponent from './FloorplanListActions';
import FloorplanListTileComponent from './FloorplanListTile';
import FloorplanListTableComponent from './FloorplanListTable';

export default {
  data() {
    return {
      listEnabled: false
    };
  },
  components: {
    'floorplan-list-actions': FloorplanListActionsComponent,
    'floorplan-list-tile': FloorplanListTileComponent,
    'floorplan-list-table': FloorplanListTableComponent,
    'back-to-top': BackToTopComponent
  },
  computed: {
    ...mapGetters({
      floorplans: 'floorplans',
      activeFloorplans: 'activeFloorplans',
      listMode: 'listMode',
      favourites: 'favourites',
      favouritesMode: 'favouritesMode',
      sorting: 'sorting',
      filtersFloorRange: 'filtersFloorRange',
      getLastFilteredUnits: 'getLastFilteredUnits',
      isUpdatingAvailability: 'isUpdatingAvailability'
    }),
    currentPlanList() {
      return (this.favouritesMode) ? this.favourites : this.activeFloorplans;
    },
    currentPlanListCount() {
      const plans = (this.favouritesMode) ? this.favourites : this.activeFloorplans;
      let retString = `filtered ${plans.length} of ${this.floorplans.length} floorplans`;
      if (this.favouritesMode) retString = `favourited ${plans.length} of ${this.floorplans.length} floorplans`;
      return retString;
    },
    curFilteredUnits() {
      const plans = (this.favouritesMode) ? this.favourites : this.activeFloorplans;
      const filterUnits = [];
      plans.forEach((plan) => {
        const stacks = plan.stacks;
        stacks.forEach((stack) => {
          stack.suites.forEach((suite) => {
            const pcUnit = suite.name;
            if (suite.status === 'available' && parseInt(suite.floor, 10) >= parseInt(this.filtersFloorRange.min, 10) && parseInt(suite.floor, 10) <= parseInt(this.filtersFloorRange.max, 10)) {
              filterUnits.push(pcUnit);
            }
          });
        });
      });
      return filterUnits;
    }
  },
  methods: {
    ...mapActions({
      FILTER_UNITS: 'FILTER_UNITS',
      RESET_VIEW: 'RESET_VIEW',
      SET_DIR: 'SET_DIR',
      SET_SORTING: 'SET_SORTING',
      SET_UPDATING_AVAILABILITY: 'SET_UPDATING_AVAILABILITY'
    }),
    toggleList() {
      this.listEnabled = !this.listEnabled;
    }
  },
  watch: {
    curFilteredUnits() {
      this.FILTER_UNITS(this.curFilteredUnits);
      if (this.isUpdatingAvailability) {
        return;
      }
      if (this.favouritesMode && this.favourites.length > 0) {
        this.SET_DIR({ dir: this.favourites[0].exposure.join(''), distance: 150 });
      } else {
        this.RESET_VIEW();
      }
      this.SET_SORTING(false);
    }
  }
};
</script>

<style lang="scss" scoped>
#floorplans_list {
  @media (max-width: 767px) {
    width: 100% !important;
  }

  @media screen and (max-width: $breakpoint-medium) {
    padding-top: 0;
  }

  @media screen and (min-width: $breakpoint-medium) {
    // padding-top: 60px;
    padding-bottom: 0;
  }
}

.tile-animate-item {
  transition: all 0.75s;

  &:hover {
    transition: all 0.1s;
  }
}

.tile-animate-enter, .tile-animate-leave-to
/* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.tile-animate-leave-active {
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/FloorplanList/FloorplanList.vue